<template>
  <section class="m-5">
    <div class="row">
      <div class="col mt-3 text-center">
        <h4>Recherche rapide de catégorie</h4>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-lg-4">
        <gwzAutoComplete
          id="input-autoComplete"
          :http="httpMirakl"
          v-model="hierarchyLabel"
          labelName="hierarchyLabel"
          queryParamName="hierarchyLabel"
          nameEndpoint="listMirakl"
          placeholder="Rechercher une catégorie MIRAKL"
          @response="goToCategory"
        ></gwzAutoComplete>
      </div>
    </div>
  </section>
</template>

<script>
import gwzAutoComplete from "@/components/gwzAutoComplete";

export default {
  name: "CategoriesQuickSearch.vue",
  components: { gwzAutoComplete },
  data() {
    return {
      httpMirakl: this.$gwzApi.service("categories"),
      hierarchyLabel: ""
    };
  },
  methods: {
    goToCategory(item) {
      this.$router.push({ name: "EditCategory", params: { id: item.id } });
    }
  }
};
</script>

<style scoped></style>
